export const simple = (obj) => {
    let handleType = obj.handleType || '输入';
    let fieldName = obj.fieldName || '';
    let required = obj.required || false;
    let min = obj.min || null;
    let max = obj.max || null;
    let pattern = obj.pattern || null;
    let res = [];
    if (required) {
        res.push({
            required: true,
            type: obj.type || null,
            message: '请' + handleType + fieldName,
            trigger: ['blur', 'change'],
        })
    }
    if (min && min > -1) {
        res.push({
            min: min,
            message: '长度需大于 ' + min + ' 个字符',
            trigger: ['blur', 'change'],
        })
    }
    if (max) {
        res.push({
            max: max,
            message: '长度需小于 ' + max + ' 个字符',
            trigger: ['blur', 'change'],
        })
    }
    if (pattern) {
        res.push({
            pattern: pattern,
            message: '请' + handleType + '正确的' + fieldName,
            trigger: ['blur', 'change'],
        })
    }
    return res
}


export const account = (fieldName = "账号") => {
    let res = simple({
        fieldName,
        required: true,
        max: 50
    });
    res.push(
        // 仅输入数字、字母
        {
            pattern: /^[A-Za-z0-9]+$/,
            // 正则检验前先将值转为字符串
            transform(value) {
                return String(value);
            },
            message: fieldName + '仅支持数字及字母',
            trigger: ['blur', 'change'],
        }
    )
    return res;

}

export const name = (fieldName = "姓名") => {
    return simple({
        fieldName,
        required: true,
        max: 50
    })
}

export const password = (fieldName = "密码") => {
    return simple({
        fieldName,
        required: true,
        min: 6,
        max: 20
    })
}

export const verificationCode = (fieldName = "验证码") => {
    return simple({
        fieldName,
        required: true
    })
}

export const feedbackContent = (fieldName = "反馈内容") => {
    return simple({
        fieldName,
        required: true,
        max: 500
    })
}

export const selectMerchant = () => {
    return simple({
        handleType: '选择',
        fieldName: '商户',
        required: true
    })
}

export const phoneNumber = (fieldName = "联系方式") => {
    let res = simple({
        fieldName,
        required: true,
        max: 20,
        pattern: /^(?:(?:\d{3}-)?\d{8}|^(?:\d{4}-)?\d{7,8})(?:-\d+)?$|^(?:(?:\+|00)86)?1\d{10}$/
    });
    return res;
}

export const number = (fieldName = "数字", min = 0, max = 2147483647) => {
    let res = simple({
        fieldName,
        type: 'number',
        required: true
    });
    res.push({
        min: min,
        type: 'number',
        message: fieldName + '需大于 ' + min,
        trigger: ['blur', 'change'],
    })
    res.push({
        max: max,
        type: 'number',
        message: fieldName + '需小于 ' + max,
        trigger: ['blur', 'change'],
    })
    return res;
}

export const array = (fieldName = "", min = 1, max = 1000, handleType = '选择') => {
    let res = simple({
        handleType: handleType,
        type: 'array',
        fieldName,
        required: true
    });
    return res;
}

export const perms = () => {
    let res = simple({
        fieldName: '权限字符',
        max: 50,
    });
    res.push(
        // 仅输入小写英文字母及英文冒号:
        {
            pattern: /^[a-z:]+$/,
            // 正则检验前先将值转为字符串
            transform(value) {
                return String(value);
            },
            message: '权限字符仅支持小写英文字母及英文冒号:',
            trigger: ['blur', 'change'],
        }
    )
    return res;
}


// WEBPACK FOOTER //
// ./src/utils/ruleUtil.js